<template>
    <div>
        <TheHeader class="pc-header" />
        <template>
            <BaseTitle 
                :infor="infor" 
            />
            <div class="banner">
                <img :src="infor.banner">
            </div>
            <BaseText 
                class="service-desc" 
                :text="text" 
            />
            <div class="service-list">
                <div class="service-list-title" v-html="serviceList.title"></div>
                <BaseListUlmoudle1 class="service-list-ul" :list="serviceList"/>
            </div>    
        </template>
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>
<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseText from '@/components/module/BaseText'
    import BaseListUlmoudle1 from '@/components/module/BaseListUlmoudle1'

    import '@/assets/less/module/module-base-list-ulmoudle1_service-list-ul.less'

    export default {
        name: 'PCService',
        props: {
            json: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseText,
            BaseListUlmoudle1
        },
        data: function(){
            return {}
        },
        mounted() {
        },
        computed: {
            infor: function(){
                let infor = this.json.infor;
                return infor;
            },
            text: function(){
                let text = this.json.text;
                return text;
            },
            serviceList: function(){
                let serviceList = this.json.serviceList;
                return serviceList;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/
.example-title {
    padding: 12px 0 50px;
}

.title-box {
    padding-top: 50px;
    padding-bottom: 30px;
}
.service-desc {
    padding-top: 50px;
}


.service-list {
    max-width: 1200px;
    margin: 0 auto;
}

.service-list-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 62px;
    border-left: 2px #333 solid;
    padding-left: 20px;
    margin-bottom: 50px;
    font-size: 38px;
}




@media screen and (min-width: 801px) and (max-width: 1200px) {

}

@media screen and (max-width: 800px) {

}
</style>